import React, { Component } from 'react';
import SignaturePad from 'signature_pad/dist/signature_pad.js';

class SignatureInput extends Component {
    constructor() {
        super();

        this.state = {
            deleteVisible: false
        };

        this.handleInput = this.handleInput.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleMouseOver = this.handleMouseOver.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
    }

    componentDidMount() {
        if (this.input) {
            this.inputSig = new SignaturePad(this.input);
        }
    }

    handleMouseOver() {
        this.setState({
            deleteVisible: true
        });
    }

    handleMouseLeave() {
        this.setState({
            deleteVisible: false
        });
    }

    handleInput(event) {

    }

    handleClick(event) {
        if (this.inputSig) {
            this.props.onChange(this.props.formData.id, this.inputSig.toData());
        }

        event.stopPropagation();
    }

    render() {
        const { deleteVisible } = this.state;
        const { formData, editable, onDelete } = this.props;

        if (this.inputSig && formData.value) {
            this.inputSig.fromData(formData.value);
        }

        if (!editable && this.inputSig) {
            this.inputSig.off();
        } else if (this.inputSig) {
            this.inputSig.on();
        }

        const outerDivStyle = createOuterDivStyle(formData, this.props.style, deleteVisible);

        return (
            <div
                className={this.props.className}
                style={outerDivStyle}
                onMouseDown={this.props.onMouseDown}
                onMouseUp={this.props.onMouseUp}
                onTouchStart={this.props.onTouchStart}
                onTouchEnd={this.props.onTouchEnd}
                onMouseOver={this.handleMouseOver}
                onMouseLeave={this.handleMouseLeave}
            >
                {
                    (editable) ?
                        <canvas
                            ref={ref => this.input = ref}
                            width={formData.width}
                            height={formData.height}
                            style={{ marginTop: -20 }}
                            onClick={this.handleClick}
                            onMouseDown={(event) => event.stopPropagation()}
                        /> :
                        FinalizedSignatureInput({ input: this.inputSig })

                }
                {
                    (deleteVisible) ?
                        <button type='button' onMouseDown={() => onDelete(formData.id)} style={{ marginTop: -20 }}>X</button> :
                        null
                }
            </div>
        );
    }
}

const FinalizedSignatureInput = (props) => {
    if (props.input) {
        return <img src={props.input.toDataURL()} alt=''/>
    }
    else {
        return null;
    }
};

const createOuterDivStyle = (formData, otherStyles, withBorder) => {
    let outerDivStyle = {
        width: formData.width,
        height: formData.height,
        position: 'absolute',
        padding: '5px',
        cursor: 'move',
        display: 'inline-block',
        ...otherStyles
    };

    if (withBorder) {
        outerDivStyle.border = 'solid black 1px';
    }

    return outerDivStyle;
};

export default SignatureInput;



// WEBPACK FOOTER //
// ./src/components/document-editor/signature_input.jsx